goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ProgressBarRound$default");
shadow.js.shim.module$$carbon$icons_react$es$ProgressBarRound$default = shadow.js.require(734, {}).default;
